<!--
 * @Author: wjc
 * @Date: 2025-06-18 09:09:53
 * @LastEditors: wjc
 * @LastEditTime: 2025-09-10 17:27:56
 * @Description: 
-->
<template>
  <TooltipTrigger v-bind="props">
    <slot></slot>
  </TooltipTrigger>
</template>

<script setup lang="ts">
  import type { TooltipTriggerProps } from 'reka-ui'

  import { TooltipTrigger } from 'reka-ui'

  const props = defineProps<TooltipTriggerProps>()
</script>
